import axios from "axios";

const api = axios.create({
  // baseURL: window._env_?.REkcACT_APP_API_URL || "http://localhost/backend_inv",
  baseURL: window._env_?.REACT_APP_API_URL || "https://patlasp.id/backend_inv",
});

const getToken = () =>
  localStorage.getItem("token") || sessionStorage.getItem("token");

api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      [
        "token",
        "NIP",
        "username",
        "namaLengkap",
        "idUser",
        "idRole",
        "idDepartemen",
        "isActive",
      ].forEach((k) => {
        localStorage.removeItem(k);
        sessionStorage.removeItem(k);
      });

      localStorage.setItem("expired", "1");

      window.location.href = "/backend_inv/login";
    }
    return Promise.reject(error);
  }
);

export default api;
